import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageCircle, Instagram, Facebook } from "lucide-react";
import logo from "@/assets/logo-header.png";
import PolicyModal from "@/components/common/PolicyModal";
const Footer = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const openWhatsApp = (phone: string) => {
    const formattedPhone = phone.replace(/\D/g, "");
    window.open(`https://wa.me/55${formattedPhone}`, "_blank");
  };
  return <footer className="bg-[#1b1b1b] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6 items-start">
          {/* Logo - Mobile centered, desktop left */}
          <div className="lg:col-span-2 flex justify-center lg:justify-start">
            <Link to="/" className="group">
              <img src={logo} alt="TH Coquetelaria" className="h-10 sm:h-12 w-auto transition-all duration-300 group-hover:opacity-80" width={139} height={48} loading="lazy" />
            </Link>
          </div>

          {/* Units Container - Stack on mobile, side by side on tablet+ */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Unidade Ribeirão Preto */}
            <div className="space-y-2 text-center sm:text-left">
              <h3 className="font-medium text-sm text-white mb-3">Unidade Ribeirão Preto</h3>
              <p className="text-xs text-white/70 leading-relaxed">R. Maestro Inácio Stábile, 558</p>
              <p className="text-xs text-white/70">Alto da Boa Vista</p>
              <p className="text-xs text-white/70">(16) 97400-3652</p>
              <a href="mailto:comercial.rp@thcoquetelaria.com.br" className="text-xs text-white/70 hover:text-white transition-colors block break-all">
                comercial.rp@thcoquetelaria.com.br
              </a>
              <div className="pt-2">
                <Button onClick={() => openWhatsApp("16974003652")} variant="outline" size="sm" className="bg-transparent border-white/30 text-white hover:bg-white hover:text-black rounded-[4px] text-xs px-4 transition-all duration-300 hover:scale-105">
                  <MessageCircle size={14} className="mr-2" />
                  WhatsApp
                </Button>
              </div>
            </div>

            {/* Unidade Franca */}
            <div className="space-y-2 text-center sm:text-left">
              <h3 className="font-medium text-sm text-white mb-3">Unidade Franca</h3>
              <p className="text-xs text-white/70 leading-relaxed">R. Álvaro Abranches, 1331</p>
              <p className="text-xs text-white/70">Cidade Nova</p>
              <p className="text-xs text-white/70">(16) 99266-6800</p>
              <a href="mailto:comercial@thcoquetelaria.com.br" className="text-xs text-white/70 hover:text-white transition-colors block break-all">
                comercial@thcoquetelaria.com.br
              </a>
              <div className="pt-2">
                <Button onClick={() => openWhatsApp("16992666800")} variant="outline" size="sm" className="bg-transparent border-white/30 text-white hover:bg-white hover:text-black rounded-[4px] text-xs px-4 transition-all duration-300 hover:scale-105">
                  <MessageCircle size={14} className="mr-2" />
                  WhatsApp
                </Button>
              </div>
            </div>
          </div>

          {/* Social Icons - Centered on mobile */}
          <div className="lg:col-span-2 flex items-center justify-center lg:justify-end gap-5">
            <a href="https://instagram.com/thcoquetelaria" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white/70 hover:text-white transition-all duration-300 hover:scale-110">
              <Instagram size={20} />
            </a>
            <a href="https://tiktok.com/@thcoquetelaria" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-white/70 hover:text-white transition-all duration-300 hover:scale-110">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
              </svg>
            </a>
            <a href="https://facebook.com/thcoquetelaria" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-white/70 hover:text-white transition-all duration-300 hover:scale-110">
              <Facebook size={20} />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col items-center gap-4">
          <div className="flex gap-6 text-xs text-white/50">
            <button onClick={() => setPrivacyOpen(true)} className="hover:text-white transition-colors">
              Política de Privacidade
            </button>
            <button onClick={() => setTermsOpen(true)} className="hover:text-white transition-colors">
              Termos de Uso
            </button>
          </div>
          <p className="text-xs text-white/50 text-center">
            © 2025 – TH Coquetelaria – Todos os direitos reservados. <span className="block sm:inline">Desenvolvido com amor e café por <a href="https://agnrx.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">RX®</a></span>
          </p>
        </div>

        {/* Policy Modals */}
        <PolicyModal open={privacyOpen} onOpenChange={setPrivacyOpen} type="privacy" />
        <PolicyModal open={termsOpen} onOpenChange={setTermsOpen} type="terms" />
      </div>
    </footer>;
};
export default Footer;